import { parsePhoneNumberFromString } from "libphonenumber-js";

const rEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function DataValidators(values: any) {
  let errors: any = {};

  if (!values.email) {
    errors.email = "El email es requerido";
  }

  if (!rEmail.test(values.email)) {
    errors.email = "El email ingresado es inválido";
  }

  if (!values.phone_number) {
    errors.phone_number = "Campo requerido";
  }

  if (!/^\d+$/.test(values.phone_number)) {
    errors.phone_number = "Solo debes incluir números";
  }

  if (values.phone_number.length > 10) {
    errors.phone_number = "Máximo 8 números";
  }

  const phoneNumber = parsePhoneNumberFromString(
    values.phone_number,
    "AR"
  );

  if (!phoneNumber?.isValid()) {
    errors.phone_number = "El número telefónico ingresado es inválido";
  }

  return errors;
}
